import React from "react"
import Proptypes from "prop-types"
import ReactLoading from "react-loading"

const LoadingAnimation = props => {
  return (
    <div
      className="loader-wrapper"
      id={props.display ? "loader-show" : "loader-hide"}
    >
      <ReactLoading type="bubbles" color="white" width={190} />
    </div>
  )
}

LoadingAnimation.prototype = {
  display: Proptypes.any,
}

export default LoadingAnimation
